import React from "react";

export default function TitleIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M23 5H15C14.4477 5 14 4.55225 14 4C14 3.44775 14.4477 3 15 3H23C23.5522 3 24 3.44775 24 4C24 4.55225 23.5522 5 23 5Z"
				fill="#1A1C21"
			/>
			<path
				d="M23 11H15C14.4477 11 14 10.5523 14 10C14 9.44775 14.4477 9 15 9H23C23.5522 9 24 9.44775 24 10C24 10.5523 23.5522 11 23 11Z"
				fill="#1A1C21"
			/>
			<path
				d="M23 17H1C0.44775 17 0 16.5527 0 16C0 15.4473 0.44775 15 1 15H23C23.5522 15 24 15.4473 24 16C24 16.5527 23.5522 17 23 17Z"
				fill="#1A1C21"
			/>
			<path
				d="M23 23H1C0.44775 23 0 22.5527 0 22C0 21.4473 0.44775 21 1 21H23C23.5522 21 24 21.4473 24 22C24 22.5527 23.5522 23 23 23Z"
				fill="#1A1C21"
			/>
			<path
				d="M7.62015 12V10.9226L8.75272 10.7985L8.25525 9.36184H4.82996L4.34659 10.7985L5.43778 10.9226V12H1.58398V10.9226L2.1918 10.7706C2.35762 10.7292 2.48176 10.674 2.53693 10.5082L5.56191 2H8.00666L11.0179 10.5358C11.073 10.7016 11.1837 10.7292 11.3492 10.7706L11.9846 10.9226V12H7.62015ZM6.61172 4.1131H6.52896L5.25816 7.87004H7.84084L6.61172 4.1131Z"
				fill="#1A1C21"
			/>
		</svg>
	);
}
